<template>
		
	<div class="btn-default" :id="id" :class="computed_wrapper_classes" data-style="fixed">
		<button
			@click="handleClick"
			class="flex items-center gap-2 cursor-pointer h-full"
			:class="computed_button_classes"
		>
			<div
				v-if="is_language_flag && icon_position === 'left'"
				class="h-3.5 w-4 rounded-full bg-cover"
			>
				<img :src="icon" :alt="icon_alt" class="h-full w-full object-cover" />
			</div>

			<img
				v-else-if="icon && icon_position === 'left'"
				:width="icon_size"
				:height="icon_size"
				:src="icon"
				:alt="icon_alt"
				:class="icon_classes"
			/>

			<span
				v-if="display_text"
				class="hidden md:block text-sm text-slate-950 font-bold"
				:class="text_classes"
			>
				{{ display_text }}
			</span>

			<img
				v-if="icon && icon_position === 'right'"
				:width="icon_size"
				:height="icon_size"
				:src="icon"
				:alt="icon_alt"
				:class="icon_classes"
			/>
		</button>
	</div>
</template>

<script lang="js" src="./NavButton.js"></script>
